import { cryptoCurrencySchema } from '@0xtorch/core'
import { z } from 'zod'
import { addressPrimitiveSchema, bigintTextSchema } from './primitive'

export const tokenSchema = z.object({
  address: addressPrimitiveSchema,
  name: z.string(),
  symbol: z.string(),
  decimals: z.number().int(),
  currency: cryptoCurrencySchema,
})

export const splTokenTransferSchema = z.object({
  type: z.literal('spl'),
  instructionIndex: z.number().optional(),
  innerInstructionIndex: z.number().optional(),
  token: tokenSchema,
  from: addressPrimitiveSchema.optional(),
  to: addressPrimitiveSchema.optional(),
  amount: bigintTextSchema,
  programId: addressPrimitiveSchema.optional(),
  instructionType: z.string().optional(),
})

export const nativeTokenTransferSchema = z.object({
  type: z.literal('native'),
  instructionIndex: z.number().optional(),
  innerInstructionIndex: z.number().optional(),
  from: addressPrimitiveSchema.optional(),
  to: addressPrimitiveSchema.optional(),
  amount: bigintTextSchema,
  programId: addressPrimitiveSchema.optional(),
  instructionType: z.string().optional(),
})

export const tokenTransferSchema = z.union([
  splTokenTransferSchema,
  nativeTokenTransferSchema,
])

export type SplTokenTransfer = z.infer<typeof splTokenTransferSchema>
export type NativeTokenTransfer = z.infer<typeof nativeTokenTransferSchema>
export type TokenTransfer = z.infer<typeof tokenTransferSchema>
